<template>
  <v-container fluid>
    <v-card>
      <v-card-title>Exam Centers</v-card-title>
      <v-divider />

      <v-card-text class="mx-auto">
        <v-data-table :headers="examCenterHeaders" :items="examCenters" />
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
export default {
  name: "MaterialsComponent",
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Dashboard/getExamCenters");
    });
  },
  computed: {
    examCenterHeaders() {
      return [
        { text: "Code", value: "code" },
        { text: "Name", value: "Name" },
        { text: "Comments", value: "Comments" },
        { text: "centerCountry", value: "centerCountry" },
        { text: "centerPostalCode", value: "centerPostalCode" },
        { text: "centerCityCode", value: "centerCityCode" },
        { text: "centerCity", value: "centerCity" },
        { text: "examCenterTimetables", value: "examCenterTimetables" },
      ];
    },
    examCenters() {
      return this.$store.getters["Dashboard/examCenters"];
    },
  },
};
</script>
